import { render, staticRenderFns } from "./MotorPremium.vue?vue&type=template&id=ba0d9838&"
import script from "./MotorPremium.vue?vue&type=script&lang=js&"
export * from "./MotorPremium.vue?vue&type=script&lang=js&"
import style0 from "./MotorPremium.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorPremium.vue"
export default component.exports